import * as React from 'react'
import { cn } from '@/lib/utils'

/**
 * PageHeader — DESIGN.md
 *
 * Standardized page title (h1). Use at the top of every route.
 *
 *   <PageHeader title="장바구니" subtitle="1개" />
 *   <PageHeader title="반품/교환 접수" description="..." />
 *
 * `title`       — required, rendered as h1 / text-xl font-bold.
 * `subtitle`    — inline next to title (e.g. count). text-sm font-normal text-muted.
 * `description` — block under title. text-sm text-muted.
 * `action`      — right-aligned slot (e.g. a button).
 */
interface PageHeaderProps {
  title: React.ReactNode
  subtitle?: React.ReactNode
  description?: React.ReactNode
  action?: React.ReactNode
  className?: string
}

export function PageHeader({
  title,
  subtitle,
  description,
  action,
  className,
}: PageHeaderProps) {
  return (
    <div className={cn('mb-4 flex items-start justify-between gap-3', className)}>
      <div className="min-w-0">
        <h1 className="text-xl font-bold text-text dark:text-gray-50">
          {title}
          {subtitle && (
            <span className="ml-2 text-sm font-normal text-text-muted">
              {subtitle}
            </span>
          )}
        </h1>
        {description && (
          <p className="mt-1 text-sm text-text-muted">{description}</p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  )
}
